(function () {
  'use strict';

  var state = {
    collections: {},
    collectionOptions: [],
    collectionMemberships: {},
    allProducts: [],
    selectedItems: [],
    maxProducts: 40,
    itemsPerPresentationBox: 8,
    filters: {
      productType: '',
      vendor: ''
    },
    sortBy: '',
    searchQuery: '',
    isLoading: true,
    currentStep: 1,
    selectedBoxColor: '',
    personalisation: {
      occasion: '',
      email: '',
      to: '',
      from: '',
      message: '',
      age: false
    },
    config: {}
  };

  function init() {
    var container = document.querySelector('[data-gift-box-builder]');
    if (!container) return;

    var configEl = container.querySelector('[data-gbb-config]');
    if (configEl) {
      try {
        state.config = JSON.parse(configEl.textContent);
      } catch (e) {
        console.error('Gift Box Builder: Failed to parse config', e);
        return;
      }
    }

    state.maxProducts = Math.max(1, parseInt(state.config.maxProducts, 10) || 40);
    state.itemsPerPresentationBox = Math.max(1, parseInt(state.config.itemsPerPresentationBox, 10) || 8);
    state.collections = {};
    state.collectionOptions = [];
    state.collectionMemberships = {};
    state.allProducts = [];
    state.filters = { productType: '', vendor: '' };
    state.sortBy = '';
    state.selectedItems = [];
    state.currentStep = 1;
    state.selectedBoxColor = '';
    state.personalisation = { occasion: '', email: '', to: '', from: '', message: '', age: false };

    var bp = state.config.boxProduct;
    if (bp && bp.variants && bp.variants.length > 0) {
      console.log('Gift Box Builder: Loaded box product', bp.title, 'with', bp.variants.length, 'variants:');
      bp.variants.forEach(function (v) {
        console.log('  Variant:', v.id, '|', v.title, '| options:', JSON.stringify(v.options), '| price:', v.price);
      });
    }

    loadAllProducts(container);
    attachEventListeners(container);
    initStickyBrowseControls(container);
    goToStep(1, container);
  }

  function initStickyBrowseControls(container) {
    var header = document.querySelector('.section-header');
    if (!header) return;

    // Match the real header height rather than assuming the logo/nav dimensions.
    function updateOffset() {
      var position = window.getComputedStyle(header).position;
      var height = position === 'sticky' || position === 'fixed'
        ? Math.ceil(header.getBoundingClientRect().height)
        : 0;
      container.style.setProperty('--gbb-header-offset', height + 'px');
    }

    updateOffset();
    if ('ResizeObserver' in window) {
      var headerObserver = new ResizeObserver(updateOffset);
      headerObserver.observe(header);
    }
    window.addEventListener('resize', updateOffset);
  }

  function getProductImage(product) {
    var url = '';
    if (product.featured_image) {
      if (typeof product.featured_image === 'string') url = product.featured_image;
      else if (product.featured_image.src) url = product.featured_image.src;
    } else if (product.image && typeof product.image === 'object' && product.image.src) {
      url = product.image.src;
    } else if (product.images && product.images.length > 0) {
      var img = product.images[0];
      if (typeof img === 'object' && img.src) url = img.src;
      else if (typeof img === 'string') url = img;
    }
    if (url) {
      var separator = url.indexOf('?') !== -1 ? '&' : '?';
      url = url + separator + 'width=600&height=600&crop=center';
    }
    return url;
  }

  function getProductDetailImage(product) {
    var url = '';
    if (product.featured_image) {
      if (typeof product.featured_image === 'string') url = product.featured_image;
      else if (product.featured_image.src) url = product.featured_image.src;
    } else if (product.image && typeof product.image === 'object' && product.image.src) {
      url = product.image.src;
    } else if (product.images && product.images.length > 0) {
      var img = product.images[0];
      if (typeof img === 'object' && img.src) url = img.src;
      else if (typeof img === 'string') url = img;
    }
    if (url) {
      var separator = url.indexOf('?') !== -1 ? '&' : '?';
      url = url + separator + 'width=1400';
    }
    return url;
  }

  function formatPriceFromDollars(dollars, symbol) {
    var price = parseFloat(dollars) || 0;
    return symbol + price.toFixed(2);
  }

  function getVariant(product) {
    if (!product.variants || !product.variants.length) return null;
    var available = product.variants.find(function (v) { return v.available; });
    return available || product.variants[0];
  }

  async function loadAllProducts(container) {
    var loadingEl = container.querySelector('.gbb-step-1__loading');
    if (loadingEl) loadingEl.style.display = 'block';

    var collections = state.config.collections || [];
    var uniqueProducts = {};

    var requests = collections.map(function (col) {
      return fetch('/collections/' + col.handle + '.json')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var collectionData = data.collection;
          var collectionTitle = collectionData ? collectionData.title : col.title;
          return fetch('/collections/' + col.handle + '/products.json?limit=250')
            .then(function (r2) { return r2.json(); })
            .then(function (productData) {
              var products = (productData.products || []).map(function (p) {
                var variant = getVariant(p);
                if (!variant) return null;
                var productTags = normalizeTags(p.tags);
                if (productHasConfiguredTag(productTags, state.config.excludeTags || state.config.excludeTag)) return null;
                return {
                  id: p.id,
                  title: p.title,
                  handle: p.handle,
                  image: getProductImage(p),
                  detailImage: getProductDetailImage(p),
                  price: variant.price,
                  compareAtPrice: variant.compare_at_price || null,
                  vendor: p.vendor || '',
                  productType: p.product_type || '',
                  description: p.body_html || '',
                  tags: productTags,
                  variantId: variant.id,
                  available: variant.available,
                  collectionHandle: col.handle,
                  collectionTitle: collectionTitle,
                  collectionHandles: [col.handle],
                  collectionTitles: [collectionTitle]
                };
              }).filter(function (p) { return p !== null; });

              state.collections[col.handle] = {
                title: collectionTitle,
                products: products
              };

              return products;
            });
        })
        .catch(function (err) {
          console.warn('Gift Box Builder: Failed to load collection ' + col.handle, err);
          state.collections[col.handle] = { title: col.title, products: [] };
          return [];
        });
    });

    var results = await Promise.all(requests);

    results.forEach(function (products, index) {
      if (!products) return;
      var configuredCollection = collections[index];
      if (configuredCollection) {
        state.collectionMemberships[configuredCollection.handle] = products.map(function (product) { return product.id; });
      }
      products.forEach(function (p) {
        if (!uniqueProducts[p.id]) {
          uniqueProducts[p.id] = p;
          state.allProducts.push(p);
        } else {
          if (uniqueProducts[p.id].collectionHandles.indexOf(p.collectionHandle) === -1) {
            uniqueProducts[p.id].collectionHandles.push(p.collectionHandle);
          }
          if (uniqueProducts[p.id].collectionTitles.indexOf(p.collectionTitle) === -1) {
            uniqueProducts[p.id].collectionTitles.push(p.collectionTitle);
          }
        }
      });
    });

    state.isLoading = false;
    if (loadingEl) loadingEl.style.display = 'none';
    updateFilters(container);
    renderProducts(container);
    renderSelectedSummary(container);
  }

  async function loadCollectionDirectory() {
    try {
      var response = await fetch('/collections.json?limit=250');
      if (!response.ok) throw new Error('Unable to load collections');
      var data = await response.json();
      var excludedHandles = [
        '100-200', '200-300', '300', 'gift-under-100', 'ready-to-gift',
        'ready-to-gift-box', 'build-a-box', 'all'
      ];

      state.collectionOptions = (data.collections || []).filter(function (collection) {
        var handle = normalizeFilterValue(collection.handle);
        if (excludedHandles.indexOf(handle) !== -1) return false;
        return handle.indexOf('ready-to-gift') !== 0;
      }).map(function (collection) {
        return { label: collection.title, value: 'collection:' + collection.handle };
      }).sort(function (a, b) {
        return a.label.localeCompare(b.label, undefined, { sensitivity: 'base' });
      });
    } catch (error) {
      state.collectionOptions = (state.config.collections || []).map(function (collection) {
        return { label: collection.title, value: 'collection:' + collection.handle };
      });
    }
  }

  function updateFilters(container) {
    var filtersContainer = container.querySelector('[data-gbb-filters]');
    if (!filtersContainer) return;

    var productTypes = uniqueValues(state.allProducts.map(function (product) { return product.productType; }));
    var vendors = uniqueValues(state.allProducts.map(function (product) { return product.vendor; }));

    var html = '<button type="button" class="gbb-filter-toggle" data-gbb-filter-toggle aria-expanded="false">' +
      '<span>Filter &amp; sort</span><span class="gbb-filter-toggle__count" data-gbb-filter-count>0</span></button>' +
      '<div class="gbb-filter-panel" data-gbb-filter-panel>' + renderSortSelect() +
      renderFilterSelect('productType', 'Filter by Product Type', productTypes.map(function (productType) { return { label: productType, value: productType }; })) +
      renderFilterSelect('vendor', 'Filter by Brand', vendors.map(function (vendor) { return { label: vendor, value: vendor }; })) +
      '<button type="button" class="gbb-filter-clear" data-gbb-clear-filters>Clear all</button>' +
      '<button type="button" class="gbb-filter-done" data-gbb-filter-done>Show products</button></div>';

    filtersContainer.innerHTML = html;
    enhanceMobileSelects(filtersContainer);

    filtersContainer.querySelectorAll('[data-filter]').forEach(function (select) {
      select.addEventListener('change', function () {
        state.filters[select.dataset.filter] = select.value;
        renderProducts(container);
        updateFilterToggleState(filtersContainer);
      });
    });

    var sortSelect = filtersContainer.querySelector('[data-gbb-sort]');
    if (sortSelect) {
      sortSelect.value = state.sortBy;
      sortSelect.addEventListener('change', function () {
        state.sortBy = sortSelect.value;
        renderProducts(container);
        updateFilterToggleState(filtersContainer);
      });
    }

    var clearButton = filtersContainer.querySelector('[data-gbb-clear-filters]');
    if (clearButton) {
      clearButton.addEventListener('click', function () {
        state.filters = { productType: '', vendor: '' };
        state.sortBy = '';
        filtersContainer.querySelectorAll('[data-filter]').forEach(function (select) {
          select.value = '';
        });
        if (sortSelect) sortSelect.value = '';
        syncMobileSelects(filtersContainer);
        renderProducts(container);
        updateFilterToggleState(filtersContainer);
      });
    }

    var toggleButton = filtersContainer.querySelector('[data-gbb-filter-toggle]');
    if (toggleButton) {
      toggleButton.addEventListener('click', function () {
        var isOpen = filtersContainer.classList.toggle('gbb-filters--open');
        toggleButton.setAttribute('aria-expanded', String(isOpen));
      });
    }

    var doneButton = filtersContainer.querySelector('[data-gbb-filter-done]');
    if (doneButton) {
      doneButton.addEventListener('click', function () {
        filtersContainer.classList.remove('gbb-filters--open');
        if (toggleButton) toggleButton.setAttribute('aria-expanded', 'false');
        var products = container.querySelector('.gbb-products-scroll');
        if (products) products.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }

    updateFilterToggleState(filtersContainer);
  }

  function enhanceMobileSelects(filtersContainer) {
    filtersContainer.querySelectorAll('select').forEach(function (select, selectIndex) {
      var customSelect = document.createElement('div');
      customSelect.className = 'gbb-mobile-select';

      var trigger = document.createElement('button');
      trigger.type = 'button';
      trigger.className = 'gbb-mobile-select__trigger';
      trigger.setAttribute('aria-expanded', 'false');
      trigger.setAttribute('aria-haspopup', 'listbox');
      var visibleLabel = select.closest('.gbb-filter');
      visibleLabel = visibleLabel ? visibleLabel.querySelector('.gbb-filter__label') : null;
      trigger.setAttribute('aria-label', visibleLabel ? visibleLabel.textContent : 'Select an option');

      var menu = document.createElement('div');
      menu.className = 'gbb-mobile-select__menu';
      menu.id = 'gbb-mobile-select-menu-' + selectIndex;
      menu.setAttribute('role', 'listbox');
      trigger.setAttribute('aria-controls', menu.id);

      Array.from(select.options).forEach(function (option) {
        var optionButton = document.createElement('button');
        optionButton.type = 'button';
        optionButton.className = 'gbb-mobile-select__option';
        optionButton.textContent = option.textContent;
        optionButton.dataset.value = option.value;
        optionButton.setAttribute('role', 'option');
        optionButton.setAttribute('aria-selected', String(option.selected));
        optionButton.addEventListener('click', function (event) {
          event.stopPropagation();
          select.value = option.value;
          select.dispatchEvent(new Event('change', { bubbles: true }));
          customSelect.classList.remove('gbb-mobile-select--open');
          trigger.setAttribute('aria-expanded', 'false');
          syncMobileSelect(select, customSelect);
          trigger.focus();
        });
        menu.appendChild(optionButton);
      });

      trigger.addEventListener('click', function (event) {
        event.stopPropagation();
        filtersContainer.querySelectorAll('.gbb-mobile-select--open').forEach(function (openSelect) {
          if (openSelect === customSelect) return;
          openSelect.classList.remove('gbb-mobile-select--open');
          var openTrigger = openSelect.querySelector('.gbb-mobile-select__trigger');
          if (openTrigger) openTrigger.setAttribute('aria-expanded', 'false');
        });
        var isOpen = customSelect.classList.toggle('gbb-mobile-select--open');
        trigger.setAttribute('aria-expanded', String(isOpen));
      });

      select.addEventListener('change', function () {
        syncMobileSelect(select, customSelect);
      });

      customSelect.appendChild(trigger);
      customSelect.appendChild(menu);
      select.insertAdjacentElement('afterend', customSelect);
      syncMobileSelect(select, customSelect);
    });

    filtersContainer.classList.add('gbb-filters--enhanced');

    if (!filtersContainer.dataset.customSelectDismissBound) {
      document.addEventListener('click', function (event) {
        if (event.target.closest && event.target.closest('.gbb-mobile-select')) return;
        closeFilterSelects(filtersContainer);
      });

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') closeFilterSelects(filtersContainer, true);
      });

      filtersContainer.dataset.customSelectDismissBound = 'true';
    }
  }

  function closeFilterSelects(filtersContainer, restoreFocus) {
    filtersContainer.querySelectorAll('.gbb-mobile-select--open').forEach(function (customSelect) {
      customSelect.classList.remove('gbb-mobile-select--open');
      var trigger = customSelect.querySelector('.gbb-mobile-select__trigger');
      if (trigger) {
        trigger.setAttribute('aria-expanded', 'false');
        if (restoreFocus) trigger.focus();
      }
    });
  }

  function syncMobileSelect(select, customSelect) {
    var selectedOption = select.options[select.selectedIndex] || select.options[0];
    var trigger = customSelect.querySelector('.gbb-mobile-select__trigger');
    if (trigger && selectedOption) trigger.textContent = selectedOption.textContent;
    customSelect.querySelectorAll('.gbb-mobile-select__option').forEach(function (optionButton) {
      optionButton.setAttribute('aria-selected', String(optionButton.dataset.value === select.value));
    });
  }

  function syncMobileSelects(filtersContainer) {
    filtersContainer.querySelectorAll('select').forEach(function (select) {
      var customSelect = select.nextElementSibling;
      if (customSelect && customSelect.classList.contains('gbb-mobile-select')) {
        syncMobileSelect(select, customSelect);
      }
    });
  }

  function updateFilterToggleState(filtersContainer) {
    var count = Object.keys(state.filters).filter(function (key) { return Boolean(state.filters[key]); }).length;
    if (state.sortBy) count += 1;
    var countElement = filtersContainer.querySelector('[data-gbb-filter-count]');
    if (!countElement) return;
    countElement.textContent = String(count);
    countElement.classList.toggle('gbb-filter-toggle__count--visible', count > 0);
  }

  function renderSortSelect() {
    return '<div class="gbb-filter"><span class="gbb-filter__label">Sort products</span>' +
      '<select class="gbb-filter__select gbb-sort__select" data-gbb-sort aria-label="Sort products">' +
      '<option value="">Sort By</option>' +
      '<option value="price-desc">Price High - Low</option>' +
      '<option value="price-asc">Price Low - High</option>' +
      '<option value="title-asc">Product Title (asc)</option>' +
      '<option value="title-desc">Product Title (desc)</option>' +
      '</select></div>';
  }

  function renderFilterSelect(name, label, options) {
    var html = '<div class="gbb-filter"><span class="gbb-filter__label">' + label + '</span>' +
      '<select class="gbb-filter__select" data-filter="' + name + '" aria-label="' + escapeHtml(label) + '">' +
      '<option value="">' + label + '</option>';

    options.forEach(function (option) {
      html += '<option value="' + escapeHtml(option.value) + '">' + escapeHtml(option.label) + '</option>';
    });

    return html + '</select></div>';
  }

  async function ensureCollectionMembership(value) {
    if (!value || value.indexOf('collection:') !== 0) return;
    var handle = value.replace('collection:', '');
    if (state.collectionMemberships[handle]) return;

    try {
      var response = await fetch('/collections/' + handle + '/products.json?limit=250');
      if (!response.ok) throw new Error('Unable to load collection');
      var data = await response.json();
      state.collectionMemberships[handle] = (data.products || []).map(function (product) { return product.id; });
    } catch (error) {
      state.collectionMemberships[handle] = [];
    }
  }

  function getFilteredProducts() {
    var products = state.allProducts.slice();
    var hasActiveFilters = Boolean(state.filters.productType || state.filters.vendor || state.searchQuery);

    if (state.filters.productType) {
      products = products.filter(function (p) {
        return p.productType === state.filters.productType;
      });
    }

    if (state.filters.vendor) {
      products = products.filter(function (p) {
        return p.vendor === state.filters.vendor;
      });
    }

    if (state.searchQuery) {
      var q = state.searchQuery.toLowerCase();
      products = products.filter(function (p) {
        return p.title.toLowerCase().indexOf(q) !== -1;
      });
    }

    if (state.sortBy === 'price-desc') {
      products.sort(function (a, b) { return parseFloat(b.price || 0) - parseFloat(a.price || 0); });
    } else if (state.sortBy === 'price-asc') {
      products.sort(function (a, b) { return parseFloat(a.price || 0) - parseFloat(b.price || 0); });
    } else if (state.sortBy === 'title-asc') {
      products.sort(function (a, b) { return String(a.title || '').localeCompare(String(b.title || ''), undefined, { sensitivity: 'base' }); });
    } else if (state.sortBy === 'title-desc') {
      products.sort(function (a, b) { return String(b.title || '').localeCompare(String(a.title || ''), undefined, { sensitivity: 'base' }); });
    } else if (!hasActiveFilters) {
      products.sort(function (a, b) {
        return Number(isOilPourerProduct(b)) - Number(isOilPourerProduct(a));
      });
    }

    return products;
  }

  function productMatchesFilter(product, value) {
    if (value.indexOf('tag:') === 0) {
      var tagValue = normalizeFilterValue(value.replace('tag:', ''));
      return (product.tags || []).some(function (tag) {
        return normalizeFilterValue(tag) === tagValue;
      });
    }

    if (value.indexOf('collection:') === 0) {
      var handle = value.replace('collection:', '');
      return (state.collectionMemberships[handle] || []).indexOf(product.id) !== -1;
    }

    return productMatchesCollectionOrTag(product, value);
  }

  function isOilPourerProduct(product) {
    var searchableValues = [product.title, product.collectionHandle, product.collectionTitle]
      .concat(product.collectionHandles || [])
      .concat(product.collectionTitles || [])
      .concat(product.tags || []);

    return searchableValues.some(function (value) {
      return normalizeFilterValue(value).indexOf('oil-pourer') !== -1;
    });
  }

  function normalizeTags(tags) {
    if (Array.isArray(tags)) return tags;
    if (typeof tags === 'string') {
      return tags.split(',').map(function (tag) { return tag.trim(); }).filter(Boolean);
    }
    return [];
  }

  function productHasConfiguredTag(tags, configuredTags) {
    var expectedTags = String(configuredTags || '')
      .split(',')
      .map(function (tag) { return normalizeFilterValue(tag); })
      .filter(Boolean);
    if (expectedTags.length === 0) return false;
    return (tags || []).some(function (tag) {
      return expectedTags.indexOf(normalizeFilterValue(tag)) !== -1;
    });
  }

  function normalizeFilterValue(value) {
    return String(value || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
  }

  function productMatchesCollectionOrTag(product, value) {
    var normalizedValue = normalizeFilterValue(value);
    var collectionHandles = product.collectionHandles || [product.collectionHandle];
    var collectionTitles = product.collectionTitles || [product.collectionTitle];
    var tags = product.tags || [];

    return collectionHandles.concat(collectionTitles).concat(tags).some(function (item) {
      return normalizeFilterValue(item) === normalizedValue;
    });
  }

  function isRecipientFilter(value) {
    var normalized = normalizeFilterValue(value);
    return ['baby', 'corporate', 'client', 'clients', 'him', 'her', 'kids', 'children', 'mum', 'mother', 'dad', 'father', 'recipient'].some(function (keyword) {
      return normalized.indexOf(keyword) !== -1;
    });
  }

  function uniqueValues(values) {
    var seen = {};
    return values.filter(function (value) {
      if (!value || seen[value]) return false;
      seen[value] = true;
      return true;
    }).sort();
  }

  function renderProducts(container) {
    var grid = container.querySelector('.gbb-grid');
    var emptyEl = container.querySelector('.gbb-grid__empty');
    if (!grid) return;

    var products = getFilteredProducts();

    if (products.length === 0 && !state.isLoading) {
      grid.innerHTML = '';
      if (emptyEl) emptyEl.style.display = 'block';
      return;
    }

    if (emptyEl) emptyEl.style.display = 'none';

    var symbol = state.config.currencySymbol || '$';

    var html = products.map(function (p) {
      var selectedItem = getSelectedItem(p.id);
      var isSelected = Boolean(selectedItem);
      var isCapacityBlocked = getSelectedItemsCount() >= state.maxProducts;
      var stockLimit = getProductStockLimit(p);
      var isStockBlocked = stockLimit !== null && stockLimit !== Infinity && (selectedItem ? selectedItem.qty : 0) >= stockLimit;
      var isAddDisabled = !p.available || isCapacityBlocked || isStockBlocked;

      var priceHtml = '';
      if (p.compareAtPrice && parseFloat(p.compareAtPrice) > parseFloat(p.price)) {
        priceHtml = '<span class="gbb-card__price gbb-card__price--sale">' + formatPriceFromDollars(p.price, symbol) + '</span>' +
          '<span class="gbb-card__compare-price">' + formatPriceFromDollars(p.compareAtPrice, symbol) + '</span>';
      } else {
        priceHtml = '<span class="gbb-card__price">' + formatPriceFromDollars(p.price, symbol) + '</span>';
      }

      var btnText = !p.available
        ? 'Sold out'
        : (isStockBlocked
          ? 'Maximum available'
          : (isCapacityBlocked ? state.maxProducts + ' gift limit' : (isSelected ? 'Add another' : 'Add to box')));
      var addButtonLabel = !p.available
        ? escapeHtml(p.title) + ' is sold out'
        : (isStockBlocked
          ? 'All currently available stock of ' + escapeHtml(p.title) + ' is already selected'
          : (isCapacityBlocked
            ? 'The maximum of ' + state.maxProducts + ' gifts is selected. Remove an item before adding ' + escapeHtml(p.title)
            : (isSelected ? 'Add another ' + escapeHtml(p.title) + ' to the gift box' : 'Add ' + escapeHtml(p.title) + ' to the gift box')));

      return '<div class="gbb-card' + (isSelected ? ' gbb-card--selected' : '') + '" data-product-id="' + p.id + '">' +
        '<button type="button" class="gbb-card__details-trigger" data-product-id="' + p.id + '" aria-label="View details for ' + escapeHtml(p.title) + '">' +
        '<div class="gbb-card__image-wrap">' +
        (p.image ? '<img class="gbb-card__image" src="' + p.image + '" alt="' + escapeHtml(p.title) + '" width="300" height="300" loading="lazy">' : '<div class="gbb-card__placeholder"></div>') +
        (isSelected ? '<div class="gbb-card__check" aria-label="' + selectedItem.qty + ' selected">&times;' + selectedItem.qty + '</div>' : '') +
        '</div>' +
        '<div class="gbb-card__info">' +
        '<h3 class="gbb-card__title">' + escapeHtml(p.title) + '</h3>' +
        '<div class="gbb-card__prices">' + priceHtml + '</div>' +
        '</div>' +
        '</button>' +
        '<button type="button" class="gbb-card__add' + (isSelected ? ' gbb-card__add--selected' : '') + (isAddDisabled ? ' gbb-card__add--disabled' : '') + '" ' +
        'data-product-id="' + p.id + '" ' +
        'aria-label="' + addButtonLabel + '" ' +
        'aria-pressed="' + (isSelected ? 'true' : 'false') + '" ' +
        (isAddDisabled ? 'disabled' : '') + '>' +
        btnText +
        '</button>' +
        '</div>';
    }).join('');

    grid.innerHTML = html;

    grid.querySelectorAll('.gbb-card__add').forEach(function (btn) {
      btn.addEventListener('click', async function (event) {
        event.stopPropagation();
        var productId = parseInt(btn.dataset.productId, 10);
        var product = state.allProducts.find(function (p) { return p.id === productId; });
        if (!product) return;
        btn.disabled = true;
        btn.textContent = 'Checking stock…';
        await addItem(product, container);
        renderProducts(container);
        renderSelectedSummary(container);
      });
    });

    grid.querySelectorAll('.gbb-card__details-trigger').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var productId = parseInt(trigger.dataset.productId, 10);
        openProductModal(container, productId);
      });
    });
  }

  function renderSelectedSummary(container) {
    var summaryList = container.querySelector('.gbb-selected-summary');
    var countEl = container.querySelector('.gbb-step-1__count');
    if (!summaryList) return;

    var symbol = state.config.currencySymbol || '$';
    var currencyCode = state.config.currencyCode || '';
    var selectedCount = getSelectedItemsCount();
    var html = '';

    if (selectedCount < state.maxProducts) hideLimitMessage(container);

    state.selectedItems.forEach(function (item) {
      for (var unit = 0; unit < item.qty; unit += 1) {
        html += '<div class="gbb-selected-summary__slot gbb-selected-summary__slot--filled" title="' + escapeHtml(item.title) + '">' +
          (item.image ? '<img src="' + item.image + '" alt="' + escapeHtml(item.title) + '" class="gbb-selected-summary__image" loading="lazy">' : '') +
          '<span class="gbb-selected-summary__quantity">x1</span>' +
          '<button type="button" class="gbb-selected-summary__remove" data-remove-id="' + item.id + '" aria-label="Remove one ' + escapeHtml(item.title) + '">&times;</button>' +
          '</div>';
      }
    });

    summaryList.innerHTML = html;

    summaryList.querySelectorAll('.gbb-selected-summary__remove').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var productId = parseInt(btn.dataset.removeId, 10);
        removeItem(productId);
        renderProducts(container);
        renderSelectedSummary(container);
      });
    });

    var boxCountEl = container.querySelector('[data-gbb-box-count]');
    if (boxCountEl) {
      var capacityTextEl = boxCountEl.querySelector('[data-gbb-capacity-text]');
      if (capacityTextEl) capacityTextEl.textContent = selectedCount + ' ' + (selectedCount === 1 ? 'item selected' : 'items selected');

      var additionalBoxNoteEl = boxCountEl.querySelector('[data-gbb-additional-box-note]');
      if (additionalBoxNoteEl) {
        var presentationBoxCount = getPresentationBoxCount(selectedCount);
        var needsAdditionalBox = presentationBoxCount > 1;
        additionalBoxNoteEl.hidden = !needsAdditionalBox;
        additionalBoxNoteEl.textContent = needsAdditionalBox
          ? presentationBoxCount + ' presentation boxes × ' + formatPriceFromDollars(getConfiguredBoxPrice(), symbol) + ' = ' + formatPriceFromDollars(getConfiguredBoxPrice() * presentationBoxCount, symbol) + '. We’ll arrange every piece beautifully.'
          : '';
      }
    }

    var totalEl = container.querySelector('[data-gbb-step-total]');
    if (totalEl) {
      var stepTotal = selectedCount > 0 ? getBuilderTotal() : 0;
      totalEl.textContent = formatPriceFromDollars(stepTotal, symbol) + (currencyCode ? ' ' + currencyCode : '');
    }

    var nextButton = container.querySelector('.gbb-selection-dock [data-gbb-next-step="2"]');
    if (nextButton) nextButton.disabled = selectedCount === 0;

    updateSelectionDockVisibility(container);
    updatePresentationSummary(container, selectedCount);

    if (countEl) countEl.textContent = '';
  }

  function updateSelectionDockVisibility(container) {
    var dock = container.querySelector('.gbb-selection-dock');
    var shouldShow = state.currentStep === 1 && getSelectedItemsCount() > 0;

    if (dock) {
      dock.classList.toggle('gbb-selection-dock--visible', shouldShow);
      dock.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
    }

    container.classList.toggle('gbb-builder--has-selection', shouldShow);
  }

  function getPresentationImage(color) {
    var images = state.config.presentationImages || {};
    return images[color] || '';
  }

  function getSelectedBox() {
    if (!state.selectedBoxColor) return null;
    var activeBox = getActiveBoxSize() || getBoxSizeByKey();
    var bp = state.config.boxProduct;
    if (!bp || !bp.variants || bp.variants.length === 0) {
      return {
        variantId: null,
        title: 'Asend Gift Presentation',
        image: getPresentationImage(state.selectedBoxColor),
        price: activeBox.price
      };
    }

    var colorLower = state.selectedBoxColor.toLowerCase();
    var variant = null;

    variant = bp.variants.find(function (v) {
      if (!v.options) return false;
      return v.options.some(function (opt) {
        return opt.toLowerCase().indexOf(colorLower) !== -1;
      });
    });

    if (!variant) {
      variant = bp.variants.find(function (v) {
        return v.title && v.title.toLowerCase().indexOf(colorLower) !== -1;
      });
    }

    if (!variant && bp.variants.length === 1) {
      variant = bp.variants[0];
      console.log('Gift Box Builder: Only one variant available, using it as fallback:', variant.title);
    }

    if (!variant) {
      console.warn('Gift Box Builder: No variant found matching "' + state.selectedBoxColor + '". Available:', bp.variants.map(function (v) { return v.title + ' opts:' + JSON.stringify(v.options); }));
      return {
        variantId: null,
        title: 'Asend Gift Presentation',
        image: getPresentationImage(state.selectedBoxColor) || bp.image || '',
        price: activeBox.price
      };
    }

    console.log('Gift Box Builder: Matched variant', variant.id, variant.title, 'for color', state.selectedBoxColor);

    return {
      variantId: variant.id,
      title: 'Asend Gift Presentation',
      image: getPresentationImage(state.selectedBoxColor) || variant.image || bp.image || '',
      price: activeBox.price
    };
  }

  function capturePersonalisation(container) {
    var occasion = container.querySelector('.gbb-preview__occasion');
    var email = container.querySelector('.gbb-preview__email');
    var toField = container.querySelector('.gbb-preview__to');
    var fromField = container.querySelector('.gbb-preview__from');
    var message = container.querySelector('.gbb-preview__message');
    var age = container.querySelector('.gbb-preview__age-checkbox');

    state.personalisation = {
      occasion: occasion ? occasion.value : '',
      email: email ? email.value.trim() : '',
      to: toField ? toField.value.trim() : '',
      from: fromField ? fromField.value.trim() : '',
      message: message ? message.value.trim() : '',
      age: age ? age.checked : false
    };
  }

  function restorePersonalisation(container) {
    var values = state.personalisation || {};
    var fields = {
      '.gbb-preview__occasion': values.occasion || '',
      '.gbb-preview__email': values.email || '',
      '.gbb-preview__to': values.to || '',
      '.gbb-preview__from': values.from || '',
      '.gbb-preview__message': values.message || ''
    };

    Object.keys(fields).forEach(function (selector) {
      var field = container.querySelector(selector);
      if (field) field.value = fields[selector];
    });

    var age = container.querySelector('.gbb-preview__age-checkbox');
    if (age) age.checked = Boolean(values.age);

    var occasionText = container.querySelector('.gbb-custom-select__text');
    if (occasionText) occasionText.textContent = values.occasion || 'Select an occasion';
  }

  function renderPreview(container) {
    var itemsContainer = container.querySelector('.gbb-preview__items');
    var countEl = container.querySelector('.gbb-preview__count');
    var totalEl = container.querySelector('.gbb-preview__total-price');
    var giftsSubtotalEl = container.querySelector('.gbb-preview__gifts-subtotal');
    var presentationFeeEl = container.querySelector('.gbb-preview__presentation-fee');
    var presentationImageEl = container.querySelector('.gbb-review-presentation__image');
    var presentationColourEl = container.querySelector('.gbb-review-presentation__colour');

    if (!itemsContainer) return;

    var symbol = state.config.currencySymbol || '$';
    var currencyCode = state.config.currencyCode || '';
    var box = getSelectedBox();
    var boxPrice = box ? getPackagingTotal() : 0;
    var giftsSubtotal = 0;
    var boxImage = box ? (box.image || '') : '';
    var colourName = state.selectedBoxColor ? state.selectedBoxColor.charAt(0).toUpperCase() + state.selectedBoxColor.slice(1) : '';
    var currencySuffix = currencyCode ? ' ' + currencyCode : '';
    var formatReviewPrice = function (amount) {
      return formatPriceFromDollars(amount, symbol) + currencySuffix;
    };

    var html = '';

    state.selectedItems.forEach(function (item) {
      var itemTotal = (parseFloat(item.price) || 0) * item.qty;
      giftsSubtotal += itemTotal;
      html += '<div class="gbb-preview__item" data-preview-id="' + item.id + '">' +
        '<div class="gbb-preview__image-wrap">' +
        (item.image ? '<img class="gbb-preview__image" src="' + item.image + '" alt="' + escapeHtml(item.title) + '" loading="lazy">' : '') +
        '</div>' +
        '<div class="gbb-preview__details">' +
        '<span class="gbb-preview__title">' + escapeHtml(item.title) + '</span>' +
        '<span class="gbb-preview__price">x' + item.qty + ' · ' + formatPriceFromDollars(itemTotal, symbol) + '</span>' +
        '</div>' +
        '<button class="gbb-preview__remove" data-remove-id="' + item.id + '" aria-label="Remove one ' + escapeHtml(item.title) + '">&minus;</button>' +
        '</div>';
    });

    itemsContainer.innerHTML = html;

    var selectedCount = getSelectedItemsCount();
    if (countEl) {
      countEl.textContent = selectedCount + ' ' + (selectedCount === 1 ? 'gift selected' : 'gifts selected');
    }

    if (presentationImageEl) {
      if (boxImage) {
        presentationImageEl.src = boxImage;
        presentationImageEl.alt = colourName + ' Asend Gift Presentation';
      } else {
        presentationImageEl.removeAttribute('src');
        presentationImageEl.alt = '';
      }
    }

    if (presentationColourEl) {
      presentationColourEl.textContent = colourName ? colourName + ' Presentation' : 'Gift Presentation';
    }

    if (giftsSubtotalEl) giftsSubtotalEl.textContent = formatReviewPrice(giftsSubtotal);
    if (presentationFeeEl) presentationFeeEl.textContent = formatReviewPrice(boxPrice);

    if (totalEl) {
      totalEl.textContent = formatReviewPrice(giftsSubtotal + boxPrice);
    }

    var setReviewText = function (selector, value) {
      var el = container.querySelector(selector);
      if (el) el.textContent = value || '—';
    };
    var personalisation = state.personalisation || {};
    setReviewText('[data-gbb-review-card]', personalisation.occasion);
    setReviewText('[data-gbb-review-email]', personalisation.email);
    setReviewText('[data-gbb-review-to]', personalisation.to);
    setReviewText('[data-gbb-review-from]', personalisation.from);
    setReviewText('[data-gbb-review-message]', personalisation.message);

    var submitBtn = container.querySelector('.gbb-preview__submit');
    if (submitBtn) submitBtn.disabled = selectedCount === 0;

    itemsContainer.querySelectorAll('.gbb-preview__remove').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var productId = parseInt(btn.dataset.removeId, 10);
        removeItem(productId);
        renderProducts(container);
        renderSelectedSummary(container);
        renderPreview(container);
      });
    });
  }

  function getSelectedItem(id) {
    return state.selectedItems.find(function (item) { return item.id === id; });
  }

  function getSelectedItemsCount() {
    return state.selectedItems.reduce(function (total, item) {
      return total + (item.qty || 1);
    }, 0);
  }

  function getConfiguredBoxPrice() {
    return parseFloat(state.config.presentationPrice) || 0;
  }

  function getPresentationBoxCount(selectedCount) {
    var itemCount = typeof selectedCount === 'number' ? selectedCount : getSelectedItemsCount();
    return itemCount > 0 ? Math.ceil(itemCount / state.itemsPerPresentationBox) : 0;
  }

  function getBoxSizeByKey() {
    return {
      key: 'presentation',
      label: 'Gift Presentation and Card',
      capacity: state.maxProducts,
      price: getConfiguredBoxPrice()
    };
  }

  function getActiveBoxSize() {
    if (getSelectedItemsCount() === 0) return null;
    return getBoxSizeByKey();
  }

  function updatePresentationSummary(container, selectedCount) {
    var recommendedDetailEl = container.querySelector('[data-gbb-recommended-detail]');
    var symbol = state.config.currencySymbol || '$';
    var currencyCode = state.config.currencyCode || '';
    var presentationBoxCount = getPresentationBoxCount(selectedCount);
    var presentationTotal = presentationBoxCount > 0 ? getConfiguredBoxPrice() * presentationBoxCount : getConfiguredBoxPrice();
    var feeText = formatPriceFromDollars(presentationTotal, symbol) + (currencyCode ? ' ' + currencyCode : '');
    var presentationLabel = presentationBoxCount > 1
      ? 'Gift Presentation and Card (' + presentationBoxCount + ' boxes)'
      : 'Gift Presentation and Card';

    container.querySelectorAll('[data-gbb-presentation-fee]').forEach(function (feeEl) {
      feeEl.textContent = feeText;
    });
    container.querySelectorAll('[data-gbb-presentation-label]').forEach(function (labelEl) {
      labelEl.textContent = presentationLabel;
    });
    if (recommendedDetailEl) {
      var selectedText = selectedCount > 0
        ? selectedCount + ' ' + (selectedCount === 1 ? 'item selected' : 'items selected')
        : 'Ready for your selected gifts';
      recommendedDetailEl.textContent = presentationBoxCount > 1
        ? selectedText + ' · ' + presentationBoxCount + ' presentation boxes at ' + formatPriceFromDollars(getConfiguredBoxPrice(), symbol) + ' each'
        : selectedText;
    }
  }

  function getPackagingTotal() {
    return getConfiguredBoxPrice() * getPresentationBoxCount();
  }

  function getBuilderTotal() {
    return getSelectedItemsTotal() + getPackagingTotal();
  }

  function getProductStockLimit(product) {
    if (!product || !product.inventoryLoaded) return null;
    if (!product.inventoryManaged) return Infinity;
    return Math.max(0, parseInt(product.inventoryQuantity, 10) || 0);
  }

  function showStockMessage(container, product, stockLimit) {
    if (!container || !product) return;
    var quantityText = stockLimit === 1 ? 'Only 1 is' : 'Only ' + stockLimit + ' are';
    container.querySelectorAll('[data-gbb-limit-message]').forEach(function (message) {
      message.textContent = quantityText + ' currently available for ' + product.title + '. Remove one before adding another.';
      message.style.display = 'block';
    });
  }

  async function addItem(product, container) {
    if (getSelectedItemsCount() >= state.maxProducts) {
      showLimitMessage(container);
      return false;
    }

    await loadProductDetails(product, { forceInventory: true });

    if (product.inventoryLoadFailed) {
      showErrors(container, ['We could not confirm the current stock for ' + product.title + '. Please try again.']);
      return false;
    }

    var existing = getSelectedItem(product.id);
    var selectedQuantity = existing ? existing.qty : 0;
    var stockLimit = getProductStockLimit(product);

    if (!product.available || (stockLimit !== null && stockLimit !== Infinity && selectedQuantity >= stockLimit)) {
      showStockMessage(container, product, stockLimit || 0);
      return false;
    }

    if (existing) {
      existing.qty += 1;
      hideLimitMessage(container);
      return true;
    }

    state.selectedItems.push({
      id: product.id,
      title: product.title,
      handle: product.handle,
      image: product.image,
      price: product.price,
      variantId: product.variantId,
      qty: 1
    });

    hideLimitMessage(container);
    return true;
  }

  function showLimitMessage(container) {
    if (!container) return;
    container.querySelectorAll('[data-gbb-limit-message]').forEach(function (message) {
      message.textContent = 'You can select up to ' + state.maxProducts + ' gifts. Remove an item to choose another.';
      message.style.display = 'block';
    });
  }

  function hideLimitMessage(container) {
    if (!container) return;
    container.querySelectorAll('[data-gbb-limit-message]').forEach(function (message) {
      message.style.display = 'none';
    });
  }

  function removeItem(productId) {
    var idx = state.selectedItems.findIndex(function (item) { return item.id === productId; });
    if (idx === -1) return;
    state.selectedItems[idx].qty -= 1;
    if (state.selectedItems[idx].qty <= 0) state.selectedItems.splice(idx, 1);
  }

  async function loadProductDetails(product, options) {
    if (!product) return '';
    options = options || {};
    var forceInventory = Boolean(options.forceInventory);
    if (product.detailsLoaded && product.inventoryLoaded && !forceInventory) {
      return product.detailsHtml || product.description || '';
    }

    if (product.productDataPromise && !forceInventory) {
      await product.productDataPromise;
      return product.detailsHtml || product.description || '';
    }

    product.inventoryLoadFailed = false;
    product.productDataPromise = (async function () {
      try {
        var url = '/products/' + encodeURIComponent(product.handle) + '?variant=' + encodeURIComponent(product.variantId) + '&section_id=gbb-product-details&_=' + Date.now();
        var response = await fetch(url, { cache: 'no-store' });
        if (!response.ok) throw new Error('Unable to load product details');

        var markup = await response.text();
        var documentFragment = new DOMParser().parseFromString(markup, 'text/html');
        var details = documentFragment.querySelector('[data-gbb-product-description]');
        product.detailsHtml = details ? details.innerHTML.trim() : '';
        product.detailsLoaded = true;

        if (!details) throw new Error('Product inventory metadata is unavailable');
        product.inventoryManaged = details.dataset.gbbInventoryManaged === 'true';
        product.inventoryPolicy = details.dataset.gbbInventoryPolicy || 'deny';
        product.inventoryQuantity = parseInt(details.dataset.gbbInventoryQuantity, 10) || 0;
        product.available = details.dataset.gbbVariantAvailable === 'true' && (!product.inventoryManaged || product.inventoryQuantity > 0);
        product.inventoryLoaded = true;
      } catch (error) {
        console.warn('Gift Box Builder: Failed to load product details for ' + product.handle, error);
        product.detailsHtml = product.detailsHtml || '';
        product.inventoryLoadFailed = true;
      } finally {
        product.productDataPromise = null;
      }
    })();

    await product.productDataPromise;

    return product.detailsHtml || product.description || '';
  }

  async function openProductModal(container, productId) {
    var product = state.allProducts.find(function (p) { return p.id === productId; });
    var modal = container.querySelector('[data-gbb-product-modal]');
    if (!product || !modal) return;

    var image = modal.querySelector('.gbb-product-modal__image');
    var vendor = modal.querySelector('.gbb-product-modal__vendor');
    var title = modal.querySelector('.gbb-product-modal__title');
    var price = modal.querySelector('.gbb-product-modal__price');
    var stock = modal.querySelector('[data-gbb-product-stock]');
    var rules = modal.querySelector('[data-gbb-product-rules]');
    var description = modal.querySelector('.gbb-product-modal__description');
    var addButton = modal.querySelector('.gbb-product-modal__add');
    var symbol = state.config.currencySymbol || '$';

    modal.dataset.productId = String(product.id);

    if (image) {
      image.src = product.detailImage || product.image || '';
      image.alt = product.title || '';
      image.style.display = product.image ? 'block' : 'none';
    }
    if (vendor) {
      vendor.textContent = product.vendor || '';
      vendor.style.display = product.vendor ? 'block' : 'none';
    }
    if (title) title.textContent = product.title || '';
    if (price) price.textContent = formatPriceFromDollars(product.price, symbol) + ' ' + (state.config.currencyCode || '');
    if (stock) stock.hidden = true;
    if (rules) rules.style.display = 'none';
    if (description) description.innerHTML = '<p>Loading product details…</p>';
    resetProductDescriptionDisclosure(modal);
    updateModalAddButton(addButton, product);

    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';

    var closeBtn = modal.querySelector('.gbb-product-modal__close');
    if (closeBtn) closeBtn.focus();

    var detailsHtml = await loadProductDetails(product);
    if (description && modal.dataset.productId === String(product.id)) {
      description.innerHTML = detailsHtml || '<p>No description available.</p>';
      updateProductDescriptionDisclosure(modal);
    }
    if (stock && modal.dataset.productId === String(product.id) && product.inventoryManaged && !product.inventoryLoadFailed) {
      var stockLimit = getProductStockLimit(product);
      stock.textContent = stockLimit > 0
        ? (stockLimit === 1 ? 'Only 1 available' : 'Only ' + stockLimit + ' available')
        : 'Currently out of stock';
      stock.hidden = false;
    }
    updateModalAddButton(addButton, product);
  }

  function closeProductModal(container) {
    var modal = container.querySelector('[data-gbb-product-modal]');
    if (!modal) return;
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    resetProductDescriptionDisclosure(modal);
    document.body.style.overflow = '';
  }

  function resetProductDescriptionDisclosure(modal) {
    if (!modal) return;
    var wrapper = modal.querySelector('[data-gbb-description-wrap]');
    var toggle = modal.querySelector('[data-gbb-description-toggle]');

    if (wrapper) {
      wrapper.classList.remove('is-collapsed');
    }
    if (toggle) {
      toggle.hidden = true;
      toggle.setAttribute('aria-expanded', 'false');
      toggle.textContent = 'View full details';
    }
  }

  function updateProductDescriptionDisclosure(modal) {
    if (!modal) return;
    var wrapper = modal.querySelector('[data-gbb-description-wrap]');
    var description = modal.querySelector('.gbb-product-modal__description');
    var toggle = modal.querySelector('[data-gbb-description-toggle]');
    if (!wrapper || !description || !toggle) return;

    wrapper.classList.remove('is-collapsed');
    toggle.hidden = true;
    toggle.setAttribute('aria-expanded', 'false');
    toggle.textContent = 'View full details';

    requestAnimationFrame(function () {
      wrapper.classList.add('is-collapsed');
      requestAnimationFrame(function () {
        var isLongDescription = description.scrollHeight > wrapper.clientHeight + 4;
        if (!isLongDescription) {
          wrapper.classList.remove('is-collapsed');
          return;
        }
        toggle.hidden = false;
      });
    });
  }

  function updateModalAddButton(button, product) {
    if (!button || !product) return;
    var isCapacityBlocked = getSelectedItemsCount() >= state.maxProducts;
    var selectedItem = getSelectedItem(product.id);
    var stockLimit = getProductStockLimit(product);
    var isStockBlocked = stockLimit !== null && stockLimit !== Infinity && (selectedItem ? selectedItem.qty : 0) >= stockLimit;
    button.disabled = !product.available || isCapacityBlocked || isStockBlocked;
    button.textContent = !product.available
      ? 'Sold out'
      : (isStockBlocked ? 'Maximum available' : (isCapacityBlocked ? state.maxProducts + ' gift limit' : 'Add to box'));
  }

  function goToStep(step, container) {
    state.currentStep = step;

    container.querySelectorAll('.gbb-step').forEach(function (el) {
      el.classList.toggle('gbb-step--active', parseInt(el.dataset.step, 10) === step);
    });

    container.querySelectorAll('.gbb-progress__step').forEach(function (el) {
      var stepNum = parseInt(el.dataset.step, 10);
      el.classList.toggle('gbb-progress__step--active', stepNum === step);
      el.classList.toggle('gbb-progress__step--completed', stepNum < step);
    });

    container.querySelectorAll('.gbb-progress__line').forEach(function (el) {
      var afterStep = parseInt(el.dataset.afterStep, 10);
      el.classList.toggle('gbb-progress__line--active', afterStep < step);
    });

    updateSelectionDockVisibility(container);

    if (step === 2) {
      restorePersonalisation(container);
    }

    if (step === 3) {
      capturePersonalisation(container);
      renderPreview(container);
      var submitBtn = container.querySelector('.gbb-preview__submit');
      if (submitBtn) submitBtn.disabled = getSelectedItemsCount() === 0;
    }
  }

  function validateForm(container) {
    var errors = [];
    var boxColorErr = container.querySelector('.gbb-box-color-error');
    var boxColorGroup = container.querySelector('[data-gbb-box-color]');
    var occasion = container.querySelector('.gbb-preview__occasion');
    var occasionErr = container.querySelector('.gbb-occasion-error');
    var email = container.querySelector('.gbb-preview__email');
    var emailErr = container.querySelector('.gbb-email-error');
    var toField = container.querySelector('.gbb-preview__to');
    var toErr = container.querySelector('.gbb-to-error');
    var fromField = container.querySelector('.gbb-preview__from');
    var fromErr = container.querySelector('.gbb-from-error');
    var message = container.querySelector('.gbb-preview__message');
    var messageErr = container.querySelector('.gbb-message-error');
    var ageCheckbox = container.querySelector('.gbb-preview__age-checkbox');
    var ageErr = container.querySelector('.gbb-age-error');

    if (state.selectedItems.length === 0) {
      errors.push('Please select at least one product for your gift box.');
    }

    if (!state.selectedBoxColor) {
      errors.push('box_color');
      if (boxColorErr) boxColorErr.style.display = 'block';
      if (boxColorGroup) boxColorGroup.closest('.gbb-form-group').classList.add('gbb-form-group--error');
    } else {
      if (boxColorErr) boxColorErr.style.display = 'none';
      if (boxColorGroup) boxColorGroup.closest('.gbb-form-group').classList.remove('gbb-form-group--error');
    }

    if (occasion && !occasion.value) {
      errors.push('occasion');
      if (occasionErr) occasionErr.style.display = 'block';
      var occasionGroup = occasion.closest('.gbb-form-group');
      if (occasionGroup) occasionGroup.classList.add('gbb-form-group--error');
    } else {
      if (occasionErr) occasionErr.style.display = 'none';
      if (occasion) {
        var occasionGroup2 = occasion.closest('.gbb-form-group');
        if (occasionGroup2) occasionGroup2.classList.remove('gbb-form-group--error');
      }
    }

    if (email) {
      var emailVal = email.value.trim();
      var emailValid = emailVal && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailVal);
      if (!emailValid) {
        errors.push('email');
        if (emailErr) emailErr.style.display = 'block';
        email.closest('.gbb-form-group').classList.add('gbb-form-group--error');
      } else {
        if (emailErr) emailErr.style.display = 'none';
        email.closest('.gbb-form-group').classList.remove('gbb-form-group--error');
      }
    }

    if (toField && !toField.value.trim()) {
      errors.push('to');
      if (toErr) toErr.style.display = 'block';
      toField.closest('.gbb-form-group').classList.add('gbb-form-group--error');
    } else {
      if (toErr) toErr.style.display = 'none';
      if (toField) toField.closest('.gbb-form-group').classList.remove('gbb-form-group--error');
    }

    if (fromField && !fromField.value.trim()) {
      errors.push('from');
      if (fromErr) fromErr.style.display = 'block';
      fromField.closest('.gbb-form-group').classList.add('gbb-form-group--error');
    } else {
      if (fromErr) fromErr.style.display = 'none';
      if (fromField) fromField.closest('.gbb-form-group').classList.remove('gbb-form-group--error');
    }

    if (message && !message.value.trim()) {
      errors.push('message');
      if (messageErr) messageErr.style.display = 'block';
      message.closest('.gbb-form-group').classList.add('gbb-form-group--error');
    } else {
      if (messageErr) messageErr.style.display = 'none';
      if (message) message.closest('.gbb-form-group').classList.remove('gbb-form-group--error');
    }

    if (ageCheckbox && !ageCheckbox.checked) {
      errors.push('age');
      if (ageErr) ageErr.style.display = 'block';
    } else if (ageErr) {
      ageErr.style.display = 'none';
    }

    return errors;
  }

  async function addToCart(container) {
    restorePersonalisation(container);
    var errors = validateForm(container);
    if (errors.length > 0) {
      showErrors(container, errors);
      return;
    }

    clearErrors(container);

    var submitBtn = container.querySelector('.gbb-preview__submit');
    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.classList.add('gbb-preview__submit--loading');
      submitBtn.innerHTML = 'Adding<span class="gbb-loading-dots"><span>.</span><span>.</span><span>.</span></span>';
    }

    var occasion = container.querySelector('.gbb-preview__occasion');
    var email = container.querySelector('.gbb-preview__email');
    var toField = container.querySelector('.gbb-preview__to');
    var fromField = container.querySelector('.gbb-preview__from');
    var message = container.querySelector('.gbb-preview__message');

    try {
      var inventoryErrors = [];
      for (var selectedIndex = 0; selectedIndex < state.selectedItems.length; selectedIndex += 1) {
        var selectedItem = state.selectedItems[selectedIndex];
        var selectedProduct = state.allProducts.find(function (product) { return product.id === selectedItem.id; });
        if (!selectedProduct) {
          inventoryErrors.push('We could not confirm the current stock for ' + selectedItem.title + '. Please return to Choose Gifts and try again.');
          continue;
        }

        await loadProductDetails(selectedProduct, { forceInventory: true });
        var currentLimit = getProductStockLimit(selectedProduct);
        if (selectedProduct.inventoryLoadFailed) {
          inventoryErrors.push('We could not confirm the current stock for ' + selectedItem.title + '. Please try again.');
        } else if (!selectedProduct.available || (currentLimit !== Infinity && currentLimit !== null && selectedItem.qty > currentLimit)) {
          inventoryErrors.push(selectedItem.title + ' now has only ' + currentLimit + ' available. Please adjust your selection before adding the gift to cart.');
        }
      }

      if (inventoryErrors.length > 0) {
        showErrors(container, inventoryErrors);
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.classList.remove('gbb-preview__submit--loading');
          submitBtn.textContent = 'Add gift to cart';
        }
        return;
      }

      var qeCartData = buildQeCartData({
        occasion: occasion,
        email: email,
        toField: toField,
        fromField: fromField,
        message: message
      });

      var appResponse = await fetch('/apps/qe/frontend/graphql_create_cart_order', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          cart_data: [qeCartData],
          domain: state.config.shopDomain || window.Shopify.shop,
          storeid: state.config.storeId || '',
          builder_id: state.config.builderId || '3698',
          add_product_weight: 'off'
        })
      });

      if (!appResponse.ok) {
        throw new Error('The gift box app could not create the custom-priced box.');
      }

      var appData = await appResponse.json();
      var generatedVariantId = appData && appData[0] && appData[0].variant_data && appData[0].variant_data.variant
        ? appData[0].variant_data.variant.id
        : null;

      if (!generatedVariantId) {
        throw new Error('The gift box app did not return a generated box variant.');
      }

      await new Promise(function (resolve) { setTimeout(resolve, 8000); });

      var addResponse = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{
            id: generatedVariantId,
            quantity: 1,
            properties: buildQeCartProperties(qeCartData)
          }]
        })
      });

      if (!addResponse.ok) {
        var errorData = await addResponse.json();
        throw new Error(errorData.description || 'Failed to add to cart');
      }

      window.location.href = '/cart';
    } catch (err) {
      showErrors(container, [err.message || 'Something went wrong. Please try again.']);
      if (submitBtn) {
        submitBtn.disabled = false;
        submitBtn.classList.remove('gbb-preview__submit--loading');
        submitBtn.textContent = 'Add gift to cart';
      }
    }
  }

  function getSelectedItemsTotal() {
    return state.selectedItems.reduce(function (total, item) {
      return total + ((parseFloat(item.price) || 0) * (item.qty || 1));
    }, 0);
  }

  function buildQeProduct(item) {
    var price = parseFloat(item.price) || 0;
    return {
      product_id: item.id,
      product_variant_id: item.variantId,
      product_img: item.image || '',
      product_name: item.title,
      product_options: ['Default Title - ' + (state.config.currencySymbol || '$') + price.toFixed(2)],
      product_original_price: price,
      product_price: price,
      product_qty: item.qty || 1,
      product_handle: item.handle || '',
      product_vendor: '',
      product_variant_sku: '',
      product_weight: 0,
      variant: 0,
      variantTitle: 'Default Title',
      productType: 'product'
    };
  }

  function buildQeCartData(fields) {
    var boxColor = state.selectedBoxColor === 'black' ? 'Black' : 'White';
    var boxPrice = getPackagingTotal();
    var packagingTotal = boxPrice;
    var productTotal = getSelectedItemsTotal();
    var total = packagingTotal + productTotal;
    var boxName = 'Asend Gift Presentation (' + boxColor + ')';
    var boxHandle = state.selectedBoxColor === 'black' ? 'black-box' : 'white-box';
    var boxImage = getPresentationImage(state.selectedBoxColor);

    return {
      box_key: 'qeboxkey' + (state.config.builderId || '3698') + '_' + Date.now(),
      bucket_weight_price: '',
      invt_location_name: '',
      invt_location_id: '',
      box_products_boxpricetype: 'variable_price',
      temp_bucket_total: total,
      tab_1: [{
        id: state.selectedBoxColor === 'black' ? 5614 : 5613,
        domain: state.config.shopDomain || window.Shopify.shop,
        box_productid: null,
        box_producthandle: boxHandle,
        box_name: boxName,
        box_images: boxImage,
        box_description: '',
        box_price: String(boxPrice),
        box_products_min_limit: '1',
        box_products_limit: String(state.maxProducts),
        box_redirect_on: 'cart',
        box_price_type: 'variable_price',
        box_pro_vari_id: '',
        product_id: '',
        product_variant_id: state.selectedBoxColor === 'black' ? 5614 : 5613,
        product_img: boxImage,
        product_name: boxName,
        product_options: [],
        product_original_price: boxPrice,
        product_price: boxPrice,
        product_qty: 1,
        product_handle: boxHandle,
        product_weight: 0,
        variant: 0,
        type: 'variable_price',
        variantTitle: '',
        productType: 'box',
        stepNumber: 1,
        step_name: 'Select Your Colour'
      }],
      tab_2: state.selectedItems.map(buildQeProduct),
      tab_3: [],
      tab_4: [
        { name: 'occasion', value: fields.occasion && fields.occasion.value ? fields.occasion.value : '' },
        { name: 'email', value: fields.email && fields.email.value ? fields.email.value.trim() : '' },
        { name: 'to', value: fields.toField && fields.toField.value ? fields.toField.value.trim() : '' },
        { name: 'from', value: fields.fromField && fields.fromField.value ? fields.fromField.value.trim() : '' },
        { name: 'gift_message', value: fields.message && fields.message.value ? fields.message.value.trim() : '' }
      ],
      delivery_date: '',
      audio_message_url: '',
      video_message_url: ''
    };
  }

  function buildQeCartProperties(qeCartData) {
    var properties = { '_handle': 'qe_byob' };
    var box = qeCartData.tab_1 && qeCartData.tab_1[0];
    if (box) {
      properties.Box = box.product_name;
      properties._boxid = box.product_variant_id || '';
      properties['Presentation boxes'] = getPresentationBoxCount();
    }

    qeCartData.tab_2.forEach(function (product, index) {
      var option = product.product_options && product.product_options[0] ? product.product_options[0].split(' - ').shift() : 'Default Title';
      var name = product.product_name;
      if (option.toLowerCase().indexOf('default') === -1) name += ' - ' + option;
      properties[name] = 'x' + product.product_qty;
      properties['_variantId' + (index + 1) + '_qty'] = product.product_variant_id + '_' + product.product_qty;
    });

    qeCartData.tab_4.forEach(function (field) {
      if (!field.value) return;
      var label = field.name.charAt(0).toUpperCase() + field.name.slice(1).replaceAll('_', ' ');
      properties[label] = field.value;
    });

    return properties;
  }

  function showErrors(container, errors) {
    clearErrors(container);
    var step = state.currentStep;
    var errorContainer = container.querySelector('.gbb-step[data-step="' + step + '"] .gbb-errors');
    if (!errorContainer) {
      errorContainer = container.querySelector('.gbb-errors');
    }
    if (!errorContainer) return;

    errorContainer.innerHTML = errors.map(function (msg) {
      return '<p class="gbb-errors__item">' + escapeHtml(msg) + '</p>';
    }).join('');
    errorContainer.style.display = 'block';
    errorContainer.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }

  function clearErrors(container) {
    container.querySelectorAll('.gbb-errors').forEach(function (el) {
      el.innerHTML = '';
      el.style.display = 'none';
    });
  }

  function escapeHtml(text) {
    var div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  }

  function attachEventListeners(container) {
    container.querySelectorAll('.gbb-box-color__input').forEach(function (radio) {
      radio.addEventListener('change', function () {
        state.selectedBoxColor = radio.value;
        var errEl = container.querySelector('.gbb-box-color-error');
        if (errEl) errEl.style.display = 'none';
        var group = container.querySelector('[data-gbb-box-color]');
        if (group) group.closest('.gbb-form-group').classList.remove('gbb-form-group--error');
      });
    });

    var searchInput = container.querySelector('.gbb-search__input');
    var searchButton = container.querySelector('.gbb-search__button');

    if (searchInput) {
      var debounceTimer;
      searchInput.addEventListener('input', function () {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(function () {
          state.searchQuery = searchInput.value.trim();
          renderProducts(container);
        }, 300);
      });
    }

    if (searchButton) {
      searchButton.addEventListener('click', function () {
        state.searchQuery = searchInput ? searchInput.value.trim() : '';
        renderProducts(container);
      });
    }

    container.querySelectorAll('[data-gbb-modal-close]').forEach(function (el) {
      el.addEventListener('click', function () {
        closeProductModal(container);
      });
    });

    var modalAddButton = container.querySelector('.gbb-product-modal__add');
    if (modalAddButton) {
      modalAddButton.addEventListener('click', async function () {
        var modal = container.querySelector('[data-gbb-product-modal]');
        var productId = modal ? parseInt(modal.dataset.productId, 10) : null;
        var product = state.allProducts.find(function (p) { return p.id === productId; });
        if (!product || modalAddButton.disabled) return;

        modalAddButton.disabled = true;
        modalAddButton.textContent = 'Checking stock…';
        if (!await addItem(product, container)) {
          updateModalAddButton(modalAddButton, product);
          return;
        }
        renderProducts(container);
        renderSelectedSummary(container);
        modalAddButton.disabled = true;
        modalAddButton.textContent = 'Added';

        setTimeout(function () {
          closeProductModal(container);
          updateModalAddButton(modalAddButton, product);
        }, 450);
      });
    }

    var descriptionToggle = container.querySelector('[data-gbb-description-toggle]');
    if (descriptionToggle) {
      descriptionToggle.addEventListener('click', function () {
        var modal = container.querySelector('[data-gbb-product-modal]');
        var wrapper = modal ? modal.querySelector('[data-gbb-description-wrap]') : null;
        if (!wrapper) return;

        var isExpanded = descriptionToggle.getAttribute('aria-expanded') === 'true';
        descriptionToggle.setAttribute('aria-expanded', String(!isExpanded));
        descriptionToggle.textContent = isExpanded ? 'View full details' : 'Show less';
        wrapper.classList.toggle('is-collapsed', isExpanded);
      });
    }

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      closeProductModal(container);
    });

    container.querySelectorAll('[data-gbb-next-step]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var step = parseInt(btn.dataset.gbbNextStep, 10);

        if (step === 2 && state.selectedItems.length === 0) {
          var summary = container.querySelector('.gbb-selected-summary');
          if (summary) {
            summary.innerHTML = '<p class="gbb-selected-summary__empty" style="color:#c00;">Please select at least one product for your gift box.</p>';
            summary.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
          }
          return;
        }

        if (step === 3) {
          var errors = validateForm(container);
          if (errors.length > 0) {
            showErrors(container, errors);
            return;
          }
          clearErrors(container);
        }

        goToStep(step, container);
        container.scrollIntoView({ behavior: 'smooth' });
      });
    });

    container.querySelectorAll('[data-gbb-prev-step]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var step = parseInt(btn.dataset.gbbPrevStep, 10);
        goToStep(step, container);
        container.scrollIntoView({ behavior: 'smooth' });
      });
    });

    container.querySelectorAll('[data-gbb-goto-step]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var step = parseInt(btn.dataset.gbbGotoStep, 10);
        if (step > state.currentStep) return;
        goToStep(step, container);
        container.scrollIntoView({ behavior: 'smooth' });
      });
    });

    var submitBtn = container.querySelector('.gbb-preview__submit');
    if (submitBtn) {
      submitBtn.addEventListener('click', function (e) {
        e.preventDefault();
        addToCart(container);
      });
    }
  }

  document.addEventListener('DOMContentLoaded', init);
})();
